<template>
  <social-media-mentions
    :title="$t('Dashboard.Block.SocialMediaMentions.Title')"
    :subtitle="$t('Dashboard.Block.SocialMediaMentions.Subtitle')"
    :is-dashboard="true"
  />
</template>

<script>
import SocialMediaMentions from '@/theme/default/views/social-media/SocialMediaMentions.vue'

export default {
  name      : 'SocialMediaMentionsBlock',
  components: {
    SocialMediaMentions
  }
}
</script>

<style scoped>
</style>
